// menu-full-width.js
theme.menuFullWidth = (function () {
  function getCountFromElement(element) {
    if (!element) return 0;

    var countNode = element;

    if (element.classList.contains("cart-count-bubble")) {
      countNode =
        element.querySelector("#cart-notification-count") ||
        element.querySelector('span[aria-hidden="true"]') ||
        element;
    }

    var text = (countNode.textContent || "").trim();
    var match = text.match(/\d+/);

    return match ? parseInt(match[0], 10) : 0;
  }

  function updateCountBadge(element) {
    if (!element) return;

    var count = getCountFromElement(element);

    element.classList.toggle("header-count--hidden", count < 1);
    element.setAttribute("data-header-count", String(count));
  }

  function initHeaderCounts() {
    var header =
      document.querySelector("#shopify__header__section") || document;

    function refresh() {
      header
        .querySelectorAll(
          ".wishlist__count, .compare__count, .cart-count-bubble"
        )
        .forEach(updateCountBadge);
    }

    refresh();

    var actions = header.querySelector(".header__actions");
    if (!actions) return;

    var observer = new MutationObserver(function () {
      refresh();
    });

    observer.observe(actions, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    var container = document.querySelector(
      ".header_bottom > .container, .header_bottom > .container-fluid"
    );

    var triggers = document.querySelectorAll(".header__menu_li");

    /*
      Shared across every top-level menu item. Only one full-width panel may
      ever be visible at once — this is what prevents a still-fading-out
      panel from one menu item visually overlapping the panel of whichever
      item the pointer moves to next (previously showed the wrong item's
      grandchild images bleeding over the freshly opened panel).
    */
    var activePanel = null;

    function forceClosePanel(panel) {
      if (!panel) return;

      var previousTransition = panel.style.transition;

      panel.style.transition = "none";
      panel.style.opacity = "0";
      panel.style.visibility = "hidden";
      panel.style.zIndex = "";

      // Force a reflow so the browser applies "transition: none" before we
      // hand the transition back — otherwise the reset itself would animate.
      void panel.offsetHeight;

      panel.style.transition = previousTransition;
    }

    triggers.forEach(function (li) {
      var panel = li.querySelector(
        ":scope > .header__sub_menu.header__sub--has-children-parent"
      );

      if (!panel) return;

      var mainTrigger = li.querySelector(":scope > .header__menu_item");

      var tabs = Array.prototype.slice.call(
        panel.querySelectorAll(
          ":scope > .header__sub_menu_li.header__sub--has-children"
        )
      );

      function position() {
        if (!container) return;

        var containerRect = container.getBoundingClientRect();
        var containerStyle = window.getComputedStyle(container);
        var paddingLeft = parseFloat(containerStyle.paddingLeft) || 0;
        var paddingRight = parseFloat(containerStyle.paddingRight) || 0;

        var offsetParent = panel.offsetParent || document.body;
        var parentRect = offsetParent.getBoundingClientRect();

        var viewportWidth = document.documentElement.clientWidth;

        /*
          The drawer's own box (background/shadow) spans the full viewport,
          edge-to-edge — same treatment as the announcement bar above it.
        */
        panel.style.left = 0 - parentRect.left + "px";
        panel.style.width = viewportWidth + "px";
        panel.style.maxWidth = viewportWidth + "px";

        /*
          Its CONTENT (tab labels) stays inset to line up with the
          logo/menu content, not the drawer's own edges. insetLeft is the
          distance from the viewport's left edge to where the logo actually
          starts (container's outer edge + its own padding); insetRight
          mirrors that on the right side (e.g. matching the cart icon).
        */
        var insetLeft = containerRect.left + paddingLeft;
        var insetRight = viewportWidth - (containerRect.right - paddingRight);

        panel.style.paddingLeft = insetLeft + "px";
        panel.style.paddingRight = insetRight + "px";

        /*
          BLEED FIX (Sept 2026): the image-grid tray inside each tab
          (.header__sub--children__menu--grid) is the STATIC, non-scrolling
          outer box — previously this inset was applied directly to that
          tray, which meant it became a permanent, un-scrollable gap on
          both sides (the padding could never move, since the tray itself
          never moves). That's also why images got abruptly clipped on the
          right instead of bleeding smoothly, and why the left side always
          showed a fixed empty margin no matter how far you scrolled.

          The tray must carry NO horizontal padding of its own — it should
          only bleed to the true viewport edges (see header-submenu.css).
          The inset instead belongs on .header__sub--grid, the actual
          SCROLLABLE row inside the tray: that way the first image still
          lines up with the logo/menu content at rest, but as the row
          scrolls, that padding slides away with it — earlier images can
          go fully off-screen to the left, and the next image can peek in
          at the right edge before it's scrolled into view, exactly like
          the Explore Premium Picks card row.
        */
        var trays = panel.querySelectorAll(
          ".header__sub--children__menu--grid"
        );

        trays.forEach(function (tray) {
          // Clear any old inline inset directly on the static tray itself.
          tray.style.paddingLeft = "";
          tray.style.paddingRight = "";

          var scrollRow = tray.querySelector(".header__sub--grid");
          if (scrollRow) {
            scrollRow.style.paddingLeft = insetLeft + "px";
            scrollRow.style.paddingRight = insetRight + "px";
          }
        });
      }

      function setActiveTab(activeTab) {
        if (!tabs.length) return;

        tabs.forEach(function (tab) {
          var isActive = tab === activeTab;
          tab.classList.toggle("is-submenu-active", isActive);

          var link = tab.querySelector(":scope > .header__sub_menu_item");

          if (link) {
            link.setAttribute("aria-expanded", isActive ? "true" : "false");
          }
        });
      }

      function activateFirstTab() {
        if (tabs.length) {
          setActiveTab(tabs[0]);
        }
      }

      /*
        Keep the first subcategory selected as the default state.
        CSS only reveals it while the parent Catalog <li> is hovered/focused,
        so it cannot remain floating above the slideshow.
      */
      activateFirstTab();

      tabs.forEach(function (tab) {
        tab.addEventListener("mouseenter", function () {
          setActiveTab(tab);
        });

        tab.addEventListener("focusin", function () {
          setActiveTab(tab);
        });
      });

      li.addEventListener("mouseenter", function () {
        if (activePanel && activePanel !== panel) {
          forceClosePanel(activePanel);
        }

        activePanel = panel;
        panel.style.zIndex = "1000";

        position();
        activateFirstTab();

        if (mainTrigger) {
          mainTrigger.setAttribute("aria-expanded", "true");
        }
      });

      li.addEventListener("focusin", function () {
        if (activePanel && activePanel !== panel) {
          forceClosePanel(activePanel);
        }

        activePanel = panel;
        panel.style.zIndex = "1000";

        position();

        if (mainTrigger) {
          mainTrigger.setAttribute("aria-expanded", "true");
        }
      });

      li.addEventListener("mouseleave", function () {
        activateFirstTab();
        panel.style.zIndex = "";

        if (activePanel === panel) {
          activePanel = null;
        }

        if (mainTrigger) {
          mainTrigger.setAttribute("aria-expanded", "false");
        }
      });

      li.addEventListener("focusout", function (event) {
        if (!li.contains(event.relatedTarget)) {
          activateFirstTab();
          panel.style.zIndex = "";

          if (activePanel === panel) {
            activePanel = null;
          }

          if (mainTrigger) {
            mainTrigger.setAttribute("aria-expanded", "false");
          }
        }
      });

      window.addEventListener("resize", function () {
        if (li.matches(":hover") || li.matches(":focus-within")) {
          position();
        }
      });

      if (mainTrigger) {
        mainTrigger.setAttribute("aria-haspopup", "true");
        mainTrigger.setAttribute("aria-expanded", "false");
      }
    });

    initHeaderCounts();
  }

  document.addEventListener("DOMContentLoaded", init);
  return init;
})();